import { useTranslation } from "react-i18next";

import { useMobile } from "@krea/customer-features/hooks";
import AttractivenessComponent from "@krea/customer-features/shared-components/advice/attractiveness-component/AttractivenessComponent";
import ImprovementsComponent from "@krea/customer-features/shared-components/advice/improvements-component/ImprovementsComponent";
import { AdvisorCTABanner } from "@krea/customer-features/shared-components/advisor-cta-banner";
import LayoutOneColumn from "@krea/customer-features/shared-components/app/one-column";
import Button from "@krea/customer-features/shared-components/button";
import { Alert } from "@krea/shared/design-system/alerts/Alert";
import { twMerge } from "@krea/shared/design-system/tailwind-utils";

interface IDigitalAdvicePageProps {
  onSendApplicationClick: () => void;
}

export const DigitalAdvice = ({
  onSendApplicationClick,
}: IDigitalAdvicePageProps) => {
  const isMobile = useMobile();
  const { t } = useTranslation();

  const SendInButton = () => (
    <Button
      variant="outlined"
      color="primary"
      block
      size="lg"
      tabIndex={0}
      className={"tw-mt-6 tw-w-full tw-text-center"}
      onClick={onSendApplicationClick}
    >
      {t("advice.digital.submitText")}
    </Button>
  );

  return (
    <LayoutOneColumn
      aside={
        <div
          className={twMerge({
            ["tw-w-full tw-px-6 tw-bg-white"]: isMobile,
          })}
          style={
            isMobile
              ? {
                  zIndex: "100000",
                  position: "fixed",
                  left: "0",
                  bottom: "0",
                  height: "100px",
                  boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.10)",
                }
              : { display: "none" }
          }
        >
          <SendInButton />
        </div>
      }
    >
      <h1 className="tw-my-5 tw-text-4xl tw-font-semibold">
        {t("advice.digital.heading")}
      </h1>
      <Alert variant="infoAlert">{t("advice.digital.alertText")}</Alert>

      <div className="tw-rounded-lg tw-border-4 tw-border-primary-150 tw-px-5 tw-pb-5">
        <AttractivenessComponent className="tw-my-5 tw-mr-5 tw-w-full" />

        <h2 className="tw-mb-3 tw-text-2xl tw-font-semibold">
          {t("advice.digital.subheading")}
        </h2>

        <ImprovementsComponent />
      </div>
      {!isMobile && <SendInButton />}
      <AdvisorCTABanner />
    </LayoutOneColumn>
  );
};
